// extracted by mini-css-extract-plugin
export default {"textField__description":"FormFieldLabel_textField__description__zzRyu","textField__label":"FormFieldLabel_textField__label__y6pLS","Skeleton":"FormFieldLabel_Skeleton__GPhXO"};